import { MessageCircle, Mail } from 'lucide-react';
import { useOfferte } from '../context/OfferteContext';
import { useLang } from '../context/LanguageContext';

// Central WhatsApp number (international format, no + or spaces)
const WA_NUMBER = '31570238004';

export const buildWaLink = (msg) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg || '')}`;

/**
 * BookingCTA — the ONLY two CTAs used site-wide:
 *   1) Plan via WhatsApp (contextual prefill)
 *   2) Vraag offerte aan (opens global modal, optional prefill treatment)
 *
 * Props:
 *   waMessage        - prefill text for WhatsApp
 *   offerteTreatment - prefill "treatment" field in the offerte modal
 *   offerteNotes     - prefill "notes" field in the offerte modal
 *   size             - 'sm' | 'md' | 'lg'
 *   align            - 'start' | 'center'
 *   variant          - 'default' | 'compact' (compact hides icons)
 */
const BookingCTA = ({
  waMessage,
  offerteTreatment,
  offerteNotes,
  size = 'md',
  align = 'start',
  variant = 'default',
  className = '',
}) => {
  const { openOfferte } = useOfferte();
  const { ui } = useLang();

  const alignCls = align === 'center' ? 'justify-center' : '';
  const pad =
    size === 'lg'
      ? 'px-7 py-4 text-sm'
      : size === 'sm'
      ? 'px-4 py-2.5 text-xs'
      : 'px-5 py-3.5 text-sm';

  return (
    <div className={`flex flex-wrap gap-2.5 ${alignCls} ${className}`} data-testid="booking-cta">
      <a
        href={buildWaLink(waMessage || ui.waDefault)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="cta-whatsapp"
        className={`group inline-flex items-center gap-2 ${pad} rounded-md bg-[#25D366] hover:bg-[#20bd5a] text-white font-medium transition-colors`}
      >
        {variant !== 'compact' && <MessageCircle className="w-4 h-4" />}
        {ui.ctaWhatsapp}
      </a>
      <button
        type="button"
        onClick={() =>
          openOfferte({
            treatment: offerteTreatment || '',
            notes: offerteNotes || '',
          })
        }
        data-testid="cta-offerte"
        className={`group inline-flex items-center gap-2 ${pad} rounded-md border border-white/20 hover:border-[#2f6bff] hover:bg-[#2f6bff]/10 text-white font-medium transition-colors`}
      >
        {variant !== 'compact' && <Mail className="w-4 h-4" />}
        {ui.ctaOfferte}
      </button>
    </div>
  );
};

export default BookingCTA;
